import { css } from 'styled-components';

export const BtnMixin = css`
  .panda-typography--P1 {
    font-size: 14px;
  }
`;
